import {Component, OnInit, AfterViewInit, ElementRef} from '@angular/core';
import {BlogService} from '../../../shared/services/blog.service';
import {ActivatedRoute, Router} from '@angular/router';
import {error, logging} from 'protractor';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit, AfterViewInit {
    title: any;
    id: any;
    selectedData: any;
    slug: any;
    headings: any[] = [];
    contentSections: any[] = [];

    paragraphs: string[] = [];
    contentData: { heading: string | null; paragraphs: string[] }[] = [];

    activeTab = 0;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private blogServices: BlogService,
                private meta: Meta,
                private titles: Title,
                private el: ElementRef) {
        this.route.paramMap.subscribe(params => {
            this.slug = params.get('blogName');
            this.getByTitle();
        });
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        const targetDiv = this.el.nativeElement.querySelector('.content');
        const observer = new IntersectionObserver(
            ([entry]) => {
                // If the element is NOT visible (meaning it's stuck at the top)
                if (entry.boundingClientRect.top <= 10) {
                    targetDiv.classList.add('margin-applied');
                } else {
                    targetDiv.classList.remove('margin-applied');
                }
            },
            {threshold: [0]}
        );
        observer.observe(targetDiv);
    }


    goTo(url) {
        this.router.navigateByUrl(url);
    }

    getByTitle() {
        this.blogServices.getByTitle(this.slug).subscribe(data => {

            this.selectedData = data;
            this.selectedData.blog_details = this.selectedData.blog_details.map(section => ({
                ...section,
                heading: section.heading.replace(/^\d+\.?\s*/, '')
            }));



            this.updateMetaTags();
            // this.extractHeadingsAndDescriptions();
        });
    }

    selectTab(index: number): void {
        this.activeTab = index;
    }

    updateMetaTags() {
        this.titles.setTitle(this.selectedData.meta_title || this.selectedData.heading);
        this.meta.updateTag({
            name: 'description',
            content: `${this.selectedData.meta_description || this.selectedData.heading}`
        });
        this.meta.updateTag({name: 'keyword', content: `${this.selectedData.meta_keyword || 'volminttechnologies'}`});

        this.getHeadings();
    }

    getHeadings() {
        if (this.selectedData && this.selectedData?.blog_details && this.selectedData?.blog_details.length > 0) {
            this.headings = this.selectedData.blog_details.map(blog => blog.heading);
            this.headings = this.headings.map(h => h.replace(/^\d+\.?\s*/, ''));

            console.log(this.headings);
        }
    }

    scrollToSection(index: number): void {
        const element = document.getElementById('section-' + index);
        const headerOffset = 100;
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    }



}
